import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-weighing-ssbd',
    templateUrl: './weighing-ssbd.component.html',
    styleUrls: ['./weighing-ssbd.component.scss'],
    standalone: false
})
export class WeighingSSBDComponent {
    @Input() title: string = '';
    @Input() currentValue: number = 0;
    @Input() unit: string = '';
    @Input() maxValue: number | string = 0;
    @Input() maxLabel: string = '';
    @Input() isExceeded: boolean = false;
    @Input() difference: number = 0;
    @Input() exceededBadgeText: string = '';
}
